import { render, staticRenderFns } from "./KraalSelectInput.vue?vue&type=template&id=308dc996&scoped=true"
import script from "./KraalSelectInput.vue?vue&type=script&lang=ts"
export * from "./KraalSelectInput.vue?vue&type=script&lang=ts"
import style0 from "./KraalSelectInput.vue?vue&type=style&index=0&id=308dc996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308dc996",
  null
  
)

export default component.exports